// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__3xAEM","main":"Profile_main__Wh1p7","ltr":"Profile_ltr__eCIYZ","rtl":"Profile_rtl__v0P7H","theImage":"Profile_theImage__OPoyG","img":"Profile_img__PW9Sg"};